import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICRMAuthUrlPayload } from '@app-store/slices/crm/authUrl'

interface TaskAction extends Action {
    payload: ICRMAuthUrlPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.crm.authUrl

function* authUrlSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/integrations/crms/uri/service?type=${payload.typeName}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        }
    } catch (error) {
        if (payload?.sagaCB?.onError) payload.sagaCB.onError(error)
        yield put(onFailure(error))
    }
}

function* authUrlSaga(): any {
    yield takeLatest<TaskAction>(onRequest, authUrlSagaTask)
}

export default authUrlSaga
